// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"836056f3","453":"793893c1","455":"b3303dcd","977":"f21f00d1"}[chunkId] + ".chunk.js";
};